<h2 mat-dialog-title>{{'browse_from_media' | translate}}</h2>

<mat-dialog-content>
  <div class="row mt-1">
    <div class="d-flex justify-content-between mb-3">
      <div style="min-width:50%;" >
        <button [hidden]="!showBack" mat-icon-button (click)="navBack()">
          <mat-icon>keyboard_backspace</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-form-field class="w-100 search sticky-top bg-white">
    <mat-label>{{'search_title' | translate}}</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="{{'search' | translate}}">
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <div style="height:250px;">
    <ng-template #container injectComp></ng-template>
  </div>

</mat-dialog-content>

@if (selectedFile) {
  <section class="w-100 p-3 d-flex justify-content-start align-items-center" style="border-radius:12px; background-color: #ababab21;">
    @if (checkFileType(selectedFile) == 'image') {
      <img [src]="storageService.getImageThumb(selectedFile)" width="100" class="imgSelected" onerror="this.src='./../../assets/img/default.jpg'">
    }
    @if (checkFileType(selectedFile) == 'file') {
      <mat-card class="h-100 custom-card" >
        <mat-card-content class=" p-1 cursor-pointer">
          <div > <span class="card-icon material-symbols-outlined">draft</span></div>
        </mat-card-content>
      </mat-card>
    }
    @if (checkFileType(selectedFile) == 'video') {
      <mat-card class="h-100 video-card" style="position:relative;">
        <img
          [src]="storageService.getVideoThumb(selectedFile)"
          width="100"
          class="imgSelected"
          onerror="this.src='./../../assets/img/default.jpg'"
          style="object-fit:cover; border-radius:4px;"
          />
        <mat-icon class="video-icon material-symbols-outlined" style="position:absolute; bottom:4px; right:4px;">movie</mat-icon>
      </mat-card>
    }
    <div class="ps-2 ms-2 d-flex flex-column text-muted text-start">
      <span><strong>Media-URL: </strong> <span>{{selectedFile?.supportUrl}}</span></span>
      <span><strong>Name: </strong> <span>{{selectedFile?.name}}</span></span>
      <span><strong> Modified: </strong> <span>{{selectedFile?.metadata.updated | date: 'dd.MM.yyyy, HH:mm'}}</span></span>
      <span><strong>Size: </strong> <span> {{getFileSize(selectedFile?.metadata?.size)}}</span></span>
      <span><strong>Type: </strong> <span> {{selectedFile?.metadata?.contentType}}</span></span>
    </div>
  </section>
}

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancelEdit();" > {{'cancel' | translate}} </button>
  <button mat-button class="orange-button" [disabled]="!selectedFile" (click)="onSaveEdit();"  >{{'register.confirm' | translate}}</button>
</mat-dialog-actions>


